import { Map, View } from 'ol';
import { Vector as VectorLayer, Group as LayerGroup } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { defaults as defaultControls, ScaleLine } from 'ol/control';
import { fromLonLat } from 'ol/proj';
import { apply } from 'ol-mapbox-style';
import { KMZ } from '../shared/nhc-modules/ol-kmz';
import { PopupOverlay } from '../shared/nhc-modules/map-popups-breakpoints';
import { BaseMapToggle } from '../shared/nhc-modules/basemap-toggle';
import { MouseCoordinates } from '../shared/nhc-modules/mouse-coordinates';
import './style.css';

const checks = {
  "breakPoints": {
    "sort": 2,
    "divId": "bptoggle",
    "label": "Watch/Warning Breakpoints",
    "labelShort": "Watch/Warn Breakpoints",
    "checked": true,
    "lineEnd": false,
    "url": "/gis/breakpoints/current/Breakpoints.kmz",
    "format": "KMZ",
    "idStr": "Breakpoints_"
  },
  "commPoints": {
    "sort": 1,
    "divId": "sstoggle",
    "label": "Additional Storm Surge Communication Points",
    "labelShort": "Storm Surge Comm Points",
    "checked": true,
    "lineEnd": true,
    "url": "/gis/breakpoints/current/SS_Communication_Pts.kmz",
    "format": "KMZ",
    "idStr": "SS_Communication_Pts"
  }
};

/**
 * Define the scale bar control
 */
const scaleBar = new ScaleLine({
  units: "imperial",
  bar: true
});

/**
 * Define the popup overlay
 */
const popupOverlay = new PopupOverlay({
  element: document.getElementById('popup'),
  autoPan: {
    animation: {
      duration: 250,
    },
  },
  labelSource: checks,
});

/**
 * Create an ESRI basemap layer group (Light Gray)
 */
const grayLayer = new LayerGroup();
const apiKey = import.meta.env.VITE_ESRI_API_KEY;
let basemapId = "arcgis/light-gray";
let basemapURL = `https://basemapstyles-api.arcgis.com/arcgis/rest/services/styles/v2/styles/${basemapId}?token=${apiKey}`;
apply(grayLayer, basemapURL);

/**
 * Create an ESRI basemap layer group (Imagery Hybrid)
 */
const hybridLayer = new LayerGroup();
basemapId = "arcgis/imagery";
basemapURL = `https://basemapstyles-api.arcgis.com/arcgis/rest/services/styles/v2/styles/${basemapId}?worldview=unitedStatesOfAmerica&token=${apiKey}`;
apply(hybridLayer, basemapURL)

/**
 * Create an ESRI basemap layer group (NHC Light Gray Canvas)
 */
const attrLayer = new VectorLayer({
  source: new VectorSource({
    attributions: 'Sources: Esri, TomTom, Garmin, FAO, NOAA, USGS, © OpenStreetMap contributors, and the GIS User Community',
  }),
});
const nhcLayer = new LayerGroup({
  layers: [attrLayer],
});
const glStyle = "/arcgis-map-styles/nhc-light-gray-canvas.json";
apply(nhcLayer, glStyle);

/**
 * Define the base map toggle control
 */
const baseMapToggle = new BaseMapToggle({
  startLayer: nhcLayer,
  startLayerName: 'NHC Grey/Blue Canvas',
  startLayerImage: '/images/nhc-blue.jpg',
  nextLayer: hybridLayer,
  nextLayerName: 'Imagery with Labels',
  nextLayerImage: '/images/hybrid.jpg'
});

/**
 * Define the mouse coordinates control
 */
const mouseCoordinates = new MouseCoordinates({
  target: document.getElementById('container'),
});

/**
 * Define the main map object
 */
const map = new Map({
  controls: defaultControls().extend([
    scaleBar,
    baseMapToggle,
    mouseCoordinates
  ]),
  layers: [
    nhcLayer
  ],
  overlays: [popupOverlay],
  target: document.getElementById('map'),
  view: new View({
    center: fromLonLat([-82.0, 33.9]),
    zoom: 4,
    minZoom: 2,
    maxZoom: 10,
  }),
});

/**
 * Once the DOM is loaded and the page is ready...
 */
$(function() {
  // Add the checkboxes to the map
  addBoxes();
  // Load the layers onto the map
  loadLayers();
  // Add event listeners using jQuery
  addEventListeners();
});


// ================================================
// Support functions
// ================================================

/**
 * Add event listeners using jQuery
 */
function addEventListeners() {
  // checkbox events
  for (let [key, check] of Object.entries(checks)) {
    $("#" + check.divId).on("change", function (t) {
      console.log("#" + check.divId + " changed to " + t.currentTarget.checked);
      check.checked = t.currentTarget.checked;
      check.layer.setVisible(t.currentTarget.checked);
    });
  }
}

/**
 * Add the checkboxes to the map
 */
function addBoxes() {
  let layerB = document.createElement("div");
  layerB.style.fontWeight = "bold";
  layerB.style.fontSize = "12";

  let group = 1;
  for (let [key, check] of Object.entries(checks)) {
    let box = document.createElement("INPUT");
    box.setAttribute("type", "checkbox");
    box.setAttribute("name", check.divId);
    box.id = check.divId;

    box.checked = check.checked;

    let label = document.createElement("Label");
    label.setAttribute("for", check.divId);
    label.innerHTML = check.label;

    if (check.lineEnd) {
      layerB.appendChild(box);
      layerB.appendChild(label);
    }
    else {
      layerB.appendChild(box);
      layerB.appendChild(label);
      layerB.appendChild(document.createTextNode(" |"));
    }
  }
  document.getElementById("checkboxes").appendChild(layerB);
}

/**
 * Load the layers onto the map
 */
function loadLayers() {
  // Make an array of the keys in the checks object, sorted by the sort field
  const sortedKeys = Object.keys(checks).sort((a, b) => {
    return checks[a].sort - checks[b].sort;
  });
  // Loop through the sorted keys and add the layers to the map
  for (let key of sortedKeys) {
    let check = checks[key];
    let input = document.getElementById(check.divId);
    let label = document.querySelector("label[for='" + check.divId + "']");
    input.disabled = false;
    label.style.color = "black";
    check.layer = new VectorLayer({
      source: new VectorSource({
        url: check.url,
        format: new KMZ({
          showPointNames: false,
        }),
      }),
      visible: check.checked,
    });
    map.addLayer(check.layer);
  }
}
